import React, { useState } from "react";

const FilterPanel = ({
  objectCategories,
  selectedCategories,
  handleCheckboxChange,
  filterBuildings,
  listsData,
  onFetchApartments,
  onFetchPolygons,
  onFetchMapObjects, 
}) => {
  const [selectedFilters, setSelectedFilters] = useState({
    neighborhood_name: [],
    street_name: [],
    rights: [],
    usage_type: [],
    part_type: [],
    polygon_type_id: [],
    plant_type: [],
  });

  const listTypeMapping = {
    "Lagjja": "neighborhood_name",
    "Rruga": "street_name",
    "Të drejtat": "rights",
    "Natyra e shfrytëzimit": "usage_type",
    "Lloji i pjesës së ndërtesës": "part_type",
  };

  const listPlantProperties = {
    "Lloji i bimësisë": "plant_type", 
  }
  const listPolygons = {
    "Lloji i poligonit": "polygon_type_id",
  };

  const handleListSelection = (listTypeName, listId) => {
    const fieldName = listTypeMapping[listTypeName] || listPolygons[listTypeName] || listPlantProperties[listTypeName];
    if (!fieldName) return;

    setSelectedFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters };
      if (updatedFilters[fieldName]?.includes(listId)) {
        updatedFilters[fieldName] = updatedFilters[fieldName].filter(
          (id) => id !== listId
        );
      } else {
        updatedFilters[fieldName] = [
          ...(updatedFilters[fieldName] || []),
          listId,
        ];
      }
      return updatedFilters;
    });
  };

  const fetchFilteredApartments = () => {
    const filteredRequest = getFilteredRequest();
    if (!Object.keys(filteredRequest).length) {
      console.warn("No filters for apartments selected. Fetching all...");
      onFetchApartments({});
      return;
    }
    onFetchApartments(filteredRequest);
  };

  const fetchFilteredPolygons = () => {
    const filteredRequest = getFilteredRequest();
    if (!Object.keys(filteredRequest).length) {
      console.warn("No filters for polygons selected. Fetching all...");
      onFetchPolygons({});
      return;
    }
    onFetchPolygons(filteredRequest);
  };

  const fetchFilteredMapObjects = () => {
    const filteredRequest = getFilteredRequest();
    if (!Object.keys(filteredRequest).length) {
      console.warn("No filters for map objects selected. Fetching all...");
      onFetchMapObjects({});
      return;
    }
    onFetchMapObjects(filteredRequest);
  };


  const getFilteredRequest = () => {
    return Object.fromEntries(
      Object.entries(selectedFilters).filter(([_, v]) => v.length > 0)
    );
  };

  return (
    <div style={{ position: "absolute", bottom: "5%", left: "0.5%", zIndex: 95 }}>
      <button
        className="btn btn-secondary rounded-pill shadow"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRight"
        aria-controls="offcanvasRight"
      >
        <i className="fa fa-filter"></i>
      </button>

      {/* Offcanvas */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header bg-dark text-white">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">
            3D Map Filters
          </h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body p-4">
          <p className="text-muted">Choose which objects you want to see on the map.</p>

          {/* Tabs Navigation */}
          <ul className="nav nav-pills nav-justified mb-3">
            <li className="nav-item">
              <button
                className="nav-link active"
                id="buildings-tab"
                data-bs-toggle="tab"
                data-bs-target="#buildings"
                type="button"
              >
                🏢 Buildings
              </button>
            </li>
            <li className="nav-item">
              <button
                className="nav-link"
                id="apartments-tab"
                data-bs-toggle="tab"
                data-bs-target="#apartments"
                type="button"
              >
                🏠 Apartments
              </button>
            </li>
            <li className="nav-item">
              <button
                className="nav-link"
                id="polygons-tab"
                data-bs-toggle="tab"
                data-bs-target="#polygons"
                type="button"
              >
                📐 Polygons
              </button>
            </li>
            <li className="nav-item">
              <button
                className="nav-link"
                id="objects3d-tab"
                data-bs-toggle="tab"
                data-bs-target="#objects3d"
                type="button"
              >
                🧊 3D Objects
              </button>
            </li>
          </ul>

          {/* Tabs Content */}
          <div className="tab-content text-start">
            {/* Buildings Tab */}
            <div className="tab-pane fade show active" id="buildings">
              <h5 className="fw-bold">🏢 Buildings</h5>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="allBuildings"
                  checked={selectedCategories.includes("all")}
                  onChange={() => handleCheckboxChange("all")}
                />
                <label className="form-check-label" htmlFor="allBuildings">
                  All Buildings
                </label>
              </div>
              {/* Building categories */}
              {objectCategories.map((category) => (
                <div className="form-check" key={category.id}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`category-${category.id}`}
                    checked={selectedCategories.includes(category.name)}
                    onChange={() => handleCheckboxChange(category.name)}
                  />
                  <label className="form-check-label" htmlFor={`category-${category.id}`}>
                    {category.name}
                  </label>
                </div>
              ))}

              {/* Buildings Filter Button */}
              <button className="btn btn-success w-100 mt-3 shadow" onClick={filterBuildings}>
                Apply Filters
              </button>
            </div>

            {/* Apartments Tab */}
            <div className="tab-pane fade" id="apartments">
              <h5 className="fw-bold">🏠 Apartments</h5>
              {listsData?.length > 0 ? (
                listsData.map((listType) => {
                  const mappedField = listTypeMapping[listType.name];
                  if (!mappedField) return null;

                  return (
                    <div key={listType.id} className="mb-3">
                      <h6 className="fw-bold">{listType.name}</h6>
                      {listType.lists.length > 0 ? (
                        listType.lists.map((list) => (
                          <div className="form-check" key={list.id}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`list-${list.id}`}
                              checked={selectedFilters[mappedField]?.includes(list.id)}
                              onChange={() => handleListSelection(listType.name, list.id)}
                            />
                            <label className="form-check-label" htmlFor={`list-${list.id}`}>
                              {list.name}
                            </label>
                          </div>
                        ))
                      ) : (
                        <div className="text-muted">No lists available</div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div>No lists found</div>
              )}

              {/* Apartments Filter Button */}
              <button className="btn btn-success w-100 mt-3 shadow" onClick={fetchFilteredApartments}>
                Load Apartments
              </button>
            </div>

            {/* Polygons Tab */}
            <div className="tab-pane fade" id="polygons">
              <h5 className="fw-bold">📐 Polygons</h5>
              {listsData?.length > 0 ? (
                listsData.map((listType) => {
                  const mappedField = listPolygons[listType.name];
                  if (!mappedField) return null;

                  return (
                    <div key={listType.id} className="mb-3">
                      <h6 className="fw-bold">{listType.name}</h6>
                      {listType.lists.length > 0 ? (
                        listType.lists.map((list) => (
                          <div className="form-check" key={list.id}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`list-${list.id}`}
                              checked={selectedFilters[mappedField]?.includes(list.id)}
                              onChange={() => handleListSelection(listType.name, list.id)}
                            />
                            <label className="form-check-label" htmlFor={`list-${list.id}`}>
                              {list.name}
                            </label>
                          </div>
                        ))
                      ) : (
                        <div className="text-muted">No lists available</div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div>No lists found</div>
              )}

              {/* Polygons Filter Button */}
              <button className="btn btn-success w-100 mt-3 shadow" onClick={fetchFilteredPolygons}>
                Load Polygons
              </button>
            </div>

            {/* 3D Objects Tab */}
            <div className="tab-pane fade" id="objects3d">
              <h5 className="fw-bold">🧊 3D Objects</h5>
              {listsData?.length > 0 ? (
                listsData.map((listType) => {
                  const mappedField = listPlantProperties[listType.name];
                  if (mappedField !== "plant_type") return null;
                  return (
                    <div key={listType.id} className="mb-3">
                      <h6 className="fw-bold">{listType.name}</h6>
                      {listType.lists.length > 0 ? (
                        listType.lists.map((list) => (
                          <div className="form-check" key={list.id}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`list-${list.id}`}
                              checked={selectedFilters[mappedField]?.includes(list.id)}
                              onChange={() => handleListSelection(listType.name, list.id)}
                            />
                            <label className="form-check-label" htmlFor={`list-${list.id}`}>
                              {list.name}
                            </label>
                          </div>
                        ))
                      ) : (
                        <div className="text-muted">No lists available</div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div>No lists found</div>
              )}

              {/* 3D Objects Filter Button */}
              <button className="btn btn-success w-100 mt-3 shadow" onClick={fetchFilteredMapObjects}>
                Load 3D Objects
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
